import { useRef } from 'react';
import { getUniqueComponentId as getUniqueSubscriberId } from 'utils/ClientEventUtils';

/**
 * @param componentName component subscribing
 * @returns a unique identifier, up to number_max
 */
export function useUniqueSubscriberId(componentName: string) {
  const idRef = useRef('');

  if (!idRef.current) {
    idRef.current = getUniqueSubscriberId(componentName);
  }

  return idRef;
}
